module.exports = __webpack_public_path__ + "img/lock-icon-record.26272e56.png";